exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn1[data-v-53c8dec8] {\n\tmargin-bottom: 10px;\n\twidth: 250px;\n}\n", ""]);

// exports
